<template>
  <div :style="{
    height : height + 'px'
  }">
    <PinturaEditor
        v-bind="editorDefaults"
        :src="src"
        :imageWriter="imageWriter"
        @pintura:process="handleOverlayProcess($event)"
    ></PinturaEditor>

  </div>
</template>
<script>
import {Base64} from "./../common/js/base64";
// Import the editor default configuration
import {
  createDefaultImageReader,
  createDefaultImageWriter,
  createDefaultShapePreprocessor,
  markup_editor_defaults,
  plugin_annotate,
  plugin_crop,
  plugin_filter,
  plugin_filter_defaults,
  plugin_finetune,
  plugin_finetune_defaults,
  plugin_frame,
  plugin_frame_defaults,
  plugin_redact,
  plugin_resize,
  plugin_sticker,
  setPlugins
} from 'pintura';
// Import the component from `vue-pintura`
import {PinturaEditor} from 'vue-pintura';

import core from './../../local_modules/locale/zh_CN/core/zh_CN.js';
import crop from './../../local_modules/locale/zh_CN/crop/zh_CN.js';
import resize from './../../local_modules/locale/zh_CN/resize/zh_CN.js';
import filter from './../../local_modules/locale/zh_CN/filter/zh_CN.js';
import frame from './../../local_modules/locale/zh_CN/frame/zh_CN.js';
import finetune from './../../local_modules/locale/zh_CN/finetune/zh_CN.js';
import redact from './../../local_modules/locale/zh_CN/redact/zh_CN.js';
import sticker from './../../local_modules/locale/zh_CN/sticker/zh_CN.js';
import decorate from './../../local_modules/locale/zh_CN/decorate/zh_CN.js';
import annotate from './../../local_modules/locale/zh_CN/annotate/zh_CN.js';


setPlugins(plugin_crop, plugin_finetune, plugin_filter, plugin_annotate, plugin_sticker, plugin_frame, plugin_redact, plugin_resize);


export default {
  name: 'files',
  components: {
    PinturaEditor,
  },
  data() {
    return {
      height: 600,
      // Pass the editor default configuration options
      editorDefaults: ({
        imageReader: createDefaultImageReader(),
        shapePreprocessor: createDefaultShapePreprocessor(),

        ...plugin_filter_defaults,
        ...plugin_finetune_defaults,

        ...plugin_frame_defaults,
        ...markup_editor_defaults,
        cropSelectPresetOptions: [
          [undefined, '自定义'],
          [1, '正方形'],
          [16 / 9, '16:9'],
          [4 / 3, '4:3'],

          // shown when cropSelectPresetFilter is set to 'landscape'
          [2 / 1, '2:1'],
          [3 / 2, '3:2'],
          [4 / 3, '4:3'],
          [16 / 10, '16:10'],
          [16 / 9, '16:9'],

          // shown when cropSelectPresetFilter is set to 'portrait'
          [1 / 2, '1:2'],
          [2 / 3, '2:3'],
          [3 / 4, '3:4'],
          [10 / 16, '10:16'],
          [9 / 16, '9:16'],
        ]
        , locale: {
          ...core,
          ...crop,
          ...resize,
          ...filter,
          ...redact,
          ...frame,
          ...finetune,
          ...sticker,
          ...decorate,
          ...annotate
        },
        stickers: []
      }),
      // optionally. can leave out when not generating a preview thumbnail and/or output image
      imageWriter: createDefaultImageWriter({
        mimeType: 'image/png',
        store: (state, options, onprogress) =>
            new Promise((resolve, reject) => {
              const {dest} = state;

              // create a formdata object to send to the server
              const formData = new FormData();
              formData.append('file', dest, dest.name);
              formData.append('upload_type', this.$route.query.upload_type);
              formData.append('file_id', this.$route.query.file_id);

              // create a request object
              const request = new XMLHttpRequest();
              request.open('POST', this.$route.query.apiHost ? this.$route.query.apiHost :this.api.API_ROOT + '/v1/Uploads');
              request.setRequestHeader("clientType", "APP");
              request.setRequestHeader("token", this.$route.query.token || "");
              request.setRequestHeader("openId", this.$route.query.openId || '');
              // show progress in interface
              request.upload.onprogress = onprogress;

              // catch errors
              request.onerror = () => reject('网络故障，请稍后重试');
              request.ontimeout = () => reject('服务器链接超时，请重试');

              // handle success state
              request.onload = () => {
                if (request.status >= 200 && request.status < 300) {
                  // store request in state so it can be accessed by other processes
                  state.store = request;
                  resolve(state);
                } else {
                  reject('网络故障，请稍后重试');
                }
              };
              // start uploading the image
              request.send(formData);
            })
      }),
      src: ''
      // 裁剪方形图像
      // imageCropAspectRatio: 1,

    };
  },
  created() {
    document.title = '图片编辑'
    this.height = document.documentElement.clientHeight
    let src = this.$route.query.src
    this.src = src.includes('http') ? src : Base64.decode(src)
  },
  methods: {
    /**
     * 保存成功
     * @param e
     * @returns {*}
     */
    handleOverlayProcess(e) {
      let json = eval('(' + e.store.responseText + ')');
      if (json.code === 200) {
        switch (this.$route.query.upload_type) {
          case "seal_tmp_edit_save" :
            return uni.redirectTo({
              url: `/pages/users/signature/upload?seal_class=${this.$route.query.real_class}&file_id=${json.data.file_id}`
            });
          case "tmp_edit_words" :
            var params = "?type=close&event_name=editFileSuccess&file_name=&file_id=" + json.data.file_id + "&file_url=" + Base64.encode(json.data.file_url, true)
            return uni.redirectTo({
              url: '/pages/users/myTemplate/uploadCallback' + params
            });
          case "photoEditor" :
            return uni.redirectTo({
              url: `/pages/public/uploads?upload_status=success&upload_type=photoEditor&file_id=${json.data.file_id}&file_url=` + Base64.encode(json.data.file_url, true)
            });
        }
      }
    }
  }
};
</script>
<style>
@import './../../node_modules/pintura/pintura.css';
</style>